import React, { useEffect, useState } from 'react';
import { makeApiRequestAndHandleError, simpleFetch } from 'common/utils/http';
import NaturalPane from './components/NaturalPane';
import DerivedPane from './components/DerivedPane';
import { DerivedAttributeMap, AttributeNameValPair } from './interfaces';
import CreateDerivedAttributeModal from './CreateDerivedAttributeModal';

const fetchDerivedAttributes: () => Promise<{ derived_attributes: DerivedAttributeMap[] }> = () =>
  simpleFetch('/api/v1/derived');

const DerivedAttributesPage = () => {
  const [derivedAttrs, setDerivedAttrs] = useState<DerivedAttributeMap[]>([]);
  const [selectedAttr, setSelectedAttr] = useState<DerivedAttributeMap | undefined>(undefined);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [createModalInitAttr, setCreateModalInitAttr] = useState<AttributeNameValPair | undefined>(
    undefined
  );
  const openCreateModal = (naturalAttr?: AttributeNameValPair) => {
    setCreateModalInitAttr(naturalAttr);
    setIsCreateModalOpen(true);
  };

  const loadDerivedAttrs = async () => {
    makeApiRequestAndHandleError(async () => {
      const { derived_attributes: newDerivedAttrs } = await fetchDerivedAttributes();
      setDerivedAttrs(newDerivedAttrs);
      setSelectedAttr(newDerivedAttrs?.[0]);
    });
  };

  useEffect(() => {
    loadDerivedAttrs();
  }, []);

  return (
    <>
      <div style={{ display: 'flex' }}>
        <NaturalPane
          addNew={() => openCreateModal(undefined)}
          onSelectItem={setSelectedAttr}
          paneItems={derivedAttrs}
          paneName="Parent Attributes"
          selectedItem={selectedAttr}
        />
        <DerivedPane
          addNew={() => openCreateModal(selectedAttr?.attribute)}
          paneItems={selectedAttr?.derived}
          paneName="Derived Attributes"
          reload={loadDerivedAttrs}
          selectedAttr={selectedAttr}
        />
      </div>
      <CreateDerivedAttributeModal
        initialNaturalAttr={createModalInitAttr}
        isOpen={isCreateModalOpen}
        onClose={() => {
          setIsCreateModalOpen(false);
          loadDerivedAttrs();
        }}
      />
    </>
  );
};

export default DerivedAttributesPage;
